<template>
    <modal
        size="lg"
        :open="open"
        @closeModal="
            open = false;
            $emit('close');
        "
        @closeModalAndFetch="
            open = false;
            $emit('closeAndFetchModal');
        "
    >
        <form
            class="flex w-full flex-col flex-wrap space-y-3 text-gray-900 dark:text-white"
            @submit.prevent="submit"
        >
            <h1 class="border-b border-slate-500 pb-2">
                Reembolsar e Sinalizar Chargeback
            </h1>
            <label for="reason" class="sr-only">Reason</label>

            <div v-if="errors.length > 0" class="alert">
                <div v-for="error in errors" :key="error">
                    {{ error }}
                </div>
            </div>

            <p>
                <strong>Atenção:</strong> Prosseguindo, essa transação será
                estornada e classificada como chargeback.
            </p>

            <div class="mt-3">
                <h2 class="text-lg font-semibold">Detalhes da Transação</h2>
                <p><strong>ID:</strong> {{ transaction.id }}</p>
                <p>
                    <strong>Valor:</strong>
                    {{ $root.formatCurrency(transaction.paid_amount) }}
                </p>
                <p class="flex items-center">
                    <strong class="mr-2">Status:</strong>
                    <status :status="transaction.status" />
                </p>
            </div>

            <div class="mt-5 flex flex-row-reverse">
                <submit-button
                    :loading="loading"
                    :disabled="loading"
                    @keydown.enter="submit"
                >
                    Enviar
                </submit-button>

                <button
                    :disabled="loading"
                    type="button"
                    class="mr-2 inline-flex justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-300 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="$emit('close')"
                >
                    Cancelar
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "../../../components/layouts/Modal.vue";
import SubmitButton from "../../../components/forms/SubmitButton.vue";
import Status from "../../../components/layouts/Status.vue";

export default {
    props: ["transaction", "open"],
    components: { Status, SubmitButton, Modal },

    data() {
        return {
            loading: false,
            reason: null,
            errors: [],
            message: null,
        };
    },

    methods: {
        submit() {
            this.errors = [];
            this.message = null;
            this.loading = true;

            axios
                .post(
                    "/api/order/" +
                        this.transaction.order_id +
                        "/transactions/" +
                        this.transaction.id +
                        "/refund",
                    {
                        skip_balance: "SKIP",
                        refund_type: "chargeback",
                        chargeback_confirmed: true,
                        reason: "Reembolso por chargeback",
                    },
                )
                .then(({ data }) => {
                    this.loading = false;
                    this.$emit("closeModalAndFetch");

                    this.$notify(
                        {
                            group: "success",
                            title: "Sucesso",
                            text:
                                data?.message ||
                                "Solicitação de chargeback realizada com sucesso!",
                        },
                        4000,
                    );
                })
                .catch((error) => {
                    const response = error?.response;
                    const data = response?.data;
                    const isTimeout =
                        !response ||
                        response.status === 504 ||
                        error?.code === "ECONNABORTED" ||
                        data?.inconclusive === true;

                    if (isTimeout) {
                        this.$emit("closeModalAndFetch");
                        this.$notify(
                            {
                                group: "success",
                                title: "Processamento em andamento",
                                text:
                                    data?.message ||
                                    "A solicitação pode ter sido aceita. Atualizamos a lista — confira o status antes de tentar novamente.",
                            },
                            8000,
                        );
                        return;
                    }

                    const errors = Array.isArray(data?.errors)
                        ? data.errors
                        : data?.errors
                          ? Object.values(data.errors).flat()
                          : [];
                    const rawMessage =
                        errors[0] ||
                        data?.message ||
                        "Não foi possível concluir essa solicitação.";
                    const message = /curl\s*error|cURL error|ECONNABORTED|timed out/i.test(
                        String(rawMessage),
                    )
                        ? "A solicitação demorou para responder. Atualize a página e verifique o status antes de tentar novamente."
                        : rawMessage;

                    this.errors = errors.length ? [message] : [message];

                    this.$notify(
                        {
                            group: "error",
                            title: "Erro",
                            text: message,
                        },
                        4000,
                    );

                    this.loading = false;
                });
        },
    },
};
</script>
